import { render, staticRenderFns } from "./DigitalReplyMessages.vue?vue&type=template&id=30955e0c&"
import script from "./DigitalReplyMessages.vue?vue&type=script&lang=js&"
export * from "./DigitalReplyMessages.vue?vue&type=script&lang=js&"
import style0 from "./DigitalReplyMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports